import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import useFetch from "../../../../context/useFetch";

const RemoveTableRing = (props) => {
  let windowWidth = window.screen.width;
  const [openModal, setOpenModal] = useState(false);

  const RemoveBangleApi = useFetch({
    method: "delete",
    url: `Bangle_Service/${props.selectedRow.id}`,

    trigger: false,
    argFunc: (res) => {
      props.getRingsApi.reFetch();
      // toast.success("النگو موردنظر با موفقیت حذف شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false)
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const admin_change_order_to_on_cancle = () => {
    RemoveBangleApi.reFetch();
  };

  return (
    <>
      <TableIconModal
        width="w-2/5"
        isRemove={true}
        removeText="آیا از حذف النگو مورد نظر اطمینان دارید؟"
        icon={<DeleteIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleRemoveOnClick={admin_change_order_to_on_cancle}
      ></TableIconModal>
    </>
  );
};

export default RemoveTableRing;
